/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolVerifiedIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-verified"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M10.95 12.3L9.7 11.05Q9.3 10.65 8.76 10.66Q8.22 10.68 7.83 11.07Q7.42 11.47 7.42 12.01Q7.42 12.55 7.83 12.95L10.03 15.13Q10.43 15.53 10.95 15.53Q11.47 15.53 11.88 15.13L16.23 10.78Q16.63 10.38 16.63 9.84Q16.63 9.3 16.23 8.9Q15.82 8.5 15.29 8.5Q14.75 8.5 14.35 8.9ZM7.65 22.5L6.2 20L3.4 19.35Q2.9 19.23 2.61 18.82Q2.33 18.43 2.38 17.93L2.65 15.05L0.72 12.88Q0.38 12.5 0.38 12Q0.38 11.5 0.72 11.13L2.65 8.95L2.38 6.08Q2.33 5.58 2.61 5.17Q2.9 4.78 3.4 4.65L6.2 4L7.65 1.5Q7.9 1.07 8.38 0.91Q8.85 0.75 9.32 0.95L12 2.1L14.68 0.95Q15.15 0.75 15.63 0.91Q16.1 1.07 16.35 1.5L17.8 4L20.6 4.65Q21.1 4.78 21.39 5.17Q21.68 5.58 21.63 6.08L21.35 8.95L23.27 11.13Q23.63 11.5 23.63 12Q23.63 12.5 23.27 12.88L21.35 15.05L21.63 17.93Q21.68 18.43 21.39 18.82Q21.1 19.23 20.6 19.35L17.8 20L16.35 22.5Q16.1 22.93 15.63 23.09Q15.15 23.25 14.68 23.05L12 21.9L9.32 23.05Q8.85 23.25 8.38 23.09Q7.9 22.93 7.65 22.5Z" fill={color} />
    </svg>
  );
}
